import React from 'react';
import cn from 'classnames';
import styles from './Info.scss';

import { pluralize, formatNumber } from 'utils';
import { useTranslation } from 'react-i18next';

const Info = ({ className, building, client }) => {
  const { t } = useTranslation();
  const { count_flats, status, pavilions, min_square, max_square, type_id } = building.data;
  let minPrice = 0,
    minCost = 0;
  pavilions.forEach((pavilion) => {
    let { min_area_cost, cost_min } = pavilion;
    min_area_cost = Number(min_area_cost);
    cost_min = Number(cost_min);
    if (min_area_cost) {
      minPrice = minPrice ? Math.min(minPrice, min_area_cost) : min_area_cost;
    }
    if (cost_min) {
      minCost = minCost ? Math.min(minCost, cost_min) : cost_min;
    }
  });
  return (
    <div className={client ? styles.InfoClient : cn(styles.Info, className)}>
      {count_flats
        ? (
          <div>
            {status === 2
                  ? (
                    <div className={cn(styles.Inner, styles.Message)}>
                      <span>
                        {t('components.building.main.info.paused')}
                      </span>
                    </div>
              )
              : (
                <div className={styles.Inner}>
                  <div className={styles.Column}>
                    <span className={styles.Count}>{count_flats}</span>
                    <span className={styles.Name}>
                      {type_id == 2 ?
                        pluralize(count_flats, t('components.building.main.info.house'), t('components.building.main.info.house1'), t('components.building.main.info.house2'))
                        :
                        pluralize(count_flats, t('components.building.main.info.flat'), t('components.building.main.info.flat1'), t('components.building.main.info.flat2'))
                      }
                    </span>
                  </div>
                  <div className={styles.Column}>
                    <span className={styles.Count}>
                      {t('components.building.main.info.minPrice', {
                        minPrice: formatNumber(minPrice)
                      })}
                    </span>
                    <span className={styles.Name}>
                      {t('components.building.main.info.price')}
                    </span>
                  </div>
                  <div className={styles.Column}>
                    <span className={styles.Count}>
                      {t('components.building.main.info.minPrice', {
                        minPrice: formatNumber(minCost)
                      })}
                    </span>
                    <span className={styles.Name}>
                      {t('components.building.main.info.cost')}
                    </span>
                  </div>
                  <div className={styles.Column}>
                    <span className={styles.Count}>{min_square} - {max_square}</span>
                    <span className={styles.Name}>
                      {t('components.building.main.info.area')}
                    </span>
                  </div>
                </div>
              )}
          </div>
        )
        : (
          <div className={cn(styles.Inner, styles.Message)}>
            <span>
              {
                status === 2
                  ? t('components.building.main.info.paused')
                  : (type_id === 2 ? t('components.building.main.info.soldAllHouses') : t('components.building.main.info.soldAllFlats'))
              }
            </span>
          </div>
        )}
    </div>
  );
};

export default Info;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Info/Info.js